import { Box, Flex, Text } from '@chakra-ui/react'
import Image from 'next/image'
import { COLOR } from './'

const Certification: React.FC = () => {
  return (
    <Box h="100%">
      <Flex
        direction={['column', 'column', 'column', 'row']}
        gap={['20px', '20px', '20px', '60px']}
        py={['20px', '20px', '50px']}
        alignItems="center"
      >
        <Box w={['100%', '100%', '100%', '600px']} flex="1">
          <Image
            src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/PM-1736943437443.png"
            alt="zero-2-one product certification"
            width={600}
            height={600}
            style={{
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            }}
          />
        </Box>
        <Flex
          direction="column"
          gap={['10px', '10px', '20px']}
          py={['20px', '20px', '50px']}
          flex="1"
          justifyContent="center"
          pl={['20px', '32px', '44px', '54px']}
        >
          <Text
            color="#D9D3A6"
            fontWeight="bold"
            fontSize={['xl', '2xl', '4xl']}
          >
            Accredited certification by regulatory for international standards.
          </Text>
          <Text color={COLOR.LIGHT}>
            More than just celebrity endorsement that shows results at a
            personal level, meeting the highest international standards for
            quality and safety means that you can trust Zero2One has been tested
            and approved by experts, ensuring it’s reliable and safe to use.
            Whether you’re at home or abroad, you can feel confident knowing it
            meets strict global requirements.
          </Text>
        </Flex>
      </Flex>
    </Box>
  )
}

export default Certification
